import axiosInstance from "../axiosClient";

export const getDailyCallReport = async (date, limit = 100, start_key = "") => {
  const params = { limit };
  if (date) params.date = date;
  if (start_key) params.start_key = start_key;
  return axiosInstance.get("admins/daily_call_report", { params });
};
